import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form, Input, Row, Col } from "antd";

const KioskForm = ({ form, initialValues }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  const requiredMessage = (fieldKey) => ({
    required: true,
    message: `${t("validation.pleaseEnter")} ${t(fieldKey).toLowerCase()}!`,
  });

  return (
    <Form
      form={form}
      layout="vertical"
      name="editKiosk"
      initialValues={initialValues}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="kiosk_id"
            label={t("tableHeader.kioskId")}
            rules={[requiredMessage("tableHeader.kioskId")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="name"
            label={t("tableHeader.name")}
            rules={[requiredMessage("tableHeader.name")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="company_id"
            label={t("tableHeader.companyId")}
            rules={[requiredMessage("tableHeader.companyId")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="open_time"
            label={t("tableHeader.openTime")}
            rules={[requiredMessage("tableHeader.openTime")]}
          >
            <Input type="time" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="close_time"
            label={t("tableHeader.closeTime")}
            rules={[requiredMessage("tableHeader.closeTime")]}
          >
            <Input type="time" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="address_1"
            label={t("tableHeader.address")}
            rules={[requiredMessage("tableHeader.address")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="address_2" label={t("tableHeader.address2")}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="unit_number"
            label={t("tableHeader.unitNumber")}
            rules={[requiredMessage("tableHeader.unitNumber")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="postal_code"
            label={t("tableHeader.postalCode")}
            rules={[requiredMessage("tableHeader.postalCode")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="country"
            label={t("tableHeader.country")}
            rules={[requiredMessage("tableHeader.country")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default KioskForm;
